import React, { useContext } from "react";
import PropTypes from "prop-types";
import dayjs from "dayjs";

import { formatTalentSource } from "components/UserCardList/helpers/userCard";
import {
  baseToTargetCurrency,
  loggedUserShouldINRConvert,
} from "utils/helpers/users";
import { AuthContext } from "context/providers";
import {
  CURRENCY_CONVERSION_CONFIG,
  JOB_APPLICATION_MATCH_STATUS,
} from "lookup";
import { isNumber } from "lodash";

const MatchedDetails = ({ hit, match }) => {
  const { user: loggedInUser } = useContext(AuthContext);

  if (!match?.applicationId) {
    return null;
  }

  const matchCustomerRateValue = match?.customerRate?.value;
  const matchRateValue = match?.rate?.value;
  return (
    <div className="grid grid-cols-2 gap-3 text-sm">
      <p>{getMatchedBy(match)}</p>

      <p>
        <span className="font-bold">Date: </span>
        {`${dayjs(match.updatedAt).format("MM/DD/YYYY")}`}
      </p>

      {hit.talentSource && (
        <p>
          <span className="font-bold">
            Talent Source
            {isNumber(hit.additionalMarkup) && " & Markup"}:{"  "}
          </span>
          <span>{formatTalentSource(hit)}</span>
        </p>
      )}

      {match.availableStartDate && (
        <p>
          <span className="font-bold">Available start date:</span>{" "}
          {`${dayjs(match.availableStartDate).format("MM/DD/YYYY")}`}
        </p>
      )}

      {matchRateValue && (
        <p>
          <span className="font-bold">Desired rate: </span>${matchRateValue}
          {loggedUserShouldINRConvert(loggedInUser) &&
            ` USD (${baseToTargetCurrency(
              matchRateValue,
              CURRENCY_CONVERSION_CONFIG.exchangeFactor
            )} INR)`}
        </p>
      )}

      {matchCustomerRateValue > 0 && (
        <p>
          <span className="font-bold">Customer rate: </span>$
          {matchCustomerRateValue}
          {loggedUserShouldINRConvert(loggedInUser) &&
            ` USD (${baseToTargetCurrency(
              matchCustomerRateValue,
              CURRENCY_CONVERSION_CONFIG.exchangeFactor
            )} INR)`}
        </p>
      )}

      {matchCustomerRateValue > 0 && matchRateValue && (
        <p>
          <span className="font-bold">Margin: </span>
          {Math.round(
            ((matchCustomerRateValue - matchRateValue) /
              matchCustomerRateValue) *
              100
          ).toFixed(2)}
          %
        </p>
      )}
    </div>
  );
};

MatchedDetails.propTypes = {
  hit: PropTypes.object,
  match: PropTypes.object,
};

MatchedDetails.defaultProps = {
  hit: {},
  match: {},
};

const getMatchedBy = (match) => {
  if (
    [
      JOB_APPLICATION_MATCH_STATUS.MATCHED,
      JOB_APPLICATION_MATCH_STATUS.APPLIED,
      JOB_APPLICATION_MATCH_STATUS.ACCEPTED,
      JOB_APPLICATION_MATCH_STATUS.OFFERSENT,
    ].includes(match.status)
  ) {
    return (
      <>
        <span className="font-bold">Matched By: </span>
        <>{match.matcher}</>
      </>
    );
  }
  return (
    <>
      <span className="font-bold">By: </span>
      <>{match.updater}</>
    </>
  );
};

export default MatchedDetails;
